import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const getTotalDealerCount = data => post(URL.GET_TOTAL_DEALER_COUNT, data);
export const getTotalInquiryCount = data => post(URL.GET_TOTAL_INQUIRY_COUNT, data);
export const getTotalOrderCount = data => post(URL.GET_TOTAL_ORDER_COUNT, data);
export const getPendingOrderCount = data => post(URL.GET_PENDING_ORDER_COUNT, data);
export const getRejectedOrderCount = data => post(URL.GET_REJECTED_ORDER_COUNT, data);
export const getTopSellingProduct = data => post(URL.GET_TOP_SELLING_PRODUCT, data);
export const getTotalSales = data => post(URL.GET_TOTAL_SALES, data);
export const getIndividualOrderStatusCount = data => post(URL.GET_INDIVIDUAL_ORDER_STATUS_COUNT, data);
export const getTopDealer = data => post(URL.GET_TOP_DEALER, data);
export const getTotalPurchase = data => post(URL.GET_TOTAL_PURCHASE, data);
export const getRegionWiseSales= data => post(URL.GET_REGION_WISE_SALE, data);
export const getPlantWiseSales= data => post(URL.GET_PLANT_WISE_SALE, data);
export const getStoreWiseSales= data => post(URL.GET_STORE_WISE_SALE, data);
export const getTotalPurchaseCreatedWise = data => post(URL.GET_TOTAL_PURCHASE_CREATED, data);